(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vuex"), require("VueRouter"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Vuex", "VueRouter", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["framework-app"] = factory(require("Vuex"), require("VueRouter"), require("Vue"));
	else
		root["framework-app"] = factory(root["Vuex"], root["VueRouter"], root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__5880__, __WEBPACK_EXTERNAL_MODULE__6389__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 